import styles from './PasswordPopup.module.css';
import { useEffect, useState } from 'react';

import {
    fetchUserHasPassword,
    requestForgotPasswordReset,
    requestPasswordChange,
    requestPasswordSetup
} from '../../../../Api/Backend/Auth';
import SimpleLoader from '../../../../Components/SimpleLoader/SimpleLoader';


function PasswordPopup({ auth, onClose }) {
    const [hasPassword, setHasPassword] = useState(null);
    const [currentPassword, setCurrentPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [emailSent, setEmailSent] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleFetchUserHasPassword = async () => {
        setIsLoading(true);
        setErrorMessage(null);

        await fetchUserHasPassword({
            auth: auth,
            onSuccess: (data) => {
                // console.log("User has a password set: ", data);
                setHasPassword(data);
            },
            onError: (error) => {
                console.error("Error handleFetchUserHasPassword:", error);
                setErrorMessage(error?.message || "정보를 불러오는 중 오류가 발생했습니다.");
            }
        });

        setIsLoading(false);
    }

    const handleForgotPasswordClick = async () => {
        const email = auth?.user?.email || null;
        if (!email) return;

        setIsLoading(true);
        setErrorMessage(null);

        await requestForgotPasswordReset({
            email: email,
            onSuccess: (data) => {
                setEmailSent(true);
                // console.log(data);
            },
            onError: (error) => {
                console.error("Error handleForgotPasswordClick: ", error);
                setErrorMessage(error.message || "이메일 전송 중 오류가 발생했습니다.");
            }
        });

        setIsLoading(false);
    };

    const handlePasswordChange = async () => {
        if (!currentPassword) {
            setErrorMessage("현재 비밀번호를 입력해주세요.");
            return;
        }

        setIsLoading(true);
        setErrorMessage(null);

        await requestPasswordChange({
            auth: auth,
            password: currentPassword,
            onSuccess: (data) => {
                setEmailSent(true);
                // console.log(data);
            },
            onError: (error) => {
                console.error("Error handlePasswordChange: ", error);
                setErrorMessage(error.message || "이메일 전송 중 오류가 발생했습니다.");
            }
        });

        setIsLoading(false);
    };

    const handlePasswordSetup = async () => {
        setIsLoading(true);
        setErrorMessage(null);

        await requestPasswordSetup({
            auth: auth,
            onSuccess: (data) => {
                setEmailSent(true);
                // console.log(data);
            },
            onError: (error) => {
                console.error("Error handlePasswordSetup: ", error);
                setErrorMessage(error.message || "이메일 전송 중 오류가 발생했습니다.");
            }
        });

        setIsLoading(false);
    };

    useEffect(() => {
        handleFetchUserHasPassword();
    }, []);

    return (
        <div className={styles.passwordPopup}>
            <div className={styles.header}>
                <label>비밀번호 변경</label>
                <div
                    className={styles.closeButton}
                    onClick={onClose}>
                    <img src="./images/close_icon_30.png" />
                </div>
            </div>

            <div className={styles.popupContainer}>
                {isLoading && (
                    <div className={styles.loader}>
                        <SimpleLoader />
                    </div>
                )}

                {!isLoading && emailSent && (
                    <div>
                        <h2>이메일이 발송되었습니다</h2>
                        <p>보내드린 이메일을 확인하여 새 비밀번호를 설정해 주세요.</p>
                    </div>
                )}

                {!isLoading && !emailSent && (
                    <>
                        {hasPassword === null ? (
                            <div className={styles.errorMessage}>정보를 불러오는 중 오류가 발생했습니다.</div>
                        ) : hasPassword ? (
                            <>
                                <div className={styles.passwordInput}>
                                    <label>현재 비밀번호</label>
                                    <input
                                        type="password"
                                        value={currentPassword}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                        placeholder="현재 비밀번호를 입력하세요"
                                    />
                                </div>
                                {errorMessage && 
                                    <div className={styles.errorMessage}>{errorMessage}</div>
                                }

                                <button
                                    type="button"
                                    onClick={handlePasswordChange}
                                    className={styles.requestButton}
                                >
                                    확인
                                </button>
                                <label
                                    className={styles.resetButton}
                                    onClick={handleForgotPasswordClick}
                                >
                                    비밀번호 찾기
                                </label> 
                            </>
                        ) : (
                            <>
                                <p>고객님은 SNS로그인을 사용중이므로 {auth.user.email}계정에 대한 비밀번호가 설정되어 있지 않습니다.</p>
                                <p>로그인을 이메일과 비밀번호로 이용하려면, 아래 버튼을 눌러 비밀번호를 생성해주세요.</p>
                                <button
                                    type="button"
                                    onClick={handlePasswordSetup}
                                    className={styles.requestButton}
                                >
                                    비밀번호 설정
                                </button>
                                {errorMessage && 
                                    <div className={styles.errorMessage}>{errorMessage}</div>
                                }
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default PasswordPopup;